export default __webpack_public_path__ + "static/media/hellfirestream.58d6cb1f.png";